import API from '@aws-amplify/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import i18n from '../../../../i18n';
import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';

import DatePicker from '../../../shared/datePick/DatePick.jsx';
import { ProtectedRouteContext } from '../../../Context';

import './DatePick.scss';

export default function DatePick(props) {
    /**
     * @type {ShipyardQuestion}
     */
    const question = props.question;
    const disabled = props.disabled;
    const appInstanceId = props.appInstanceId;
    const answerUpdated = props.answerUpdated; // callback func owned by Application
    const previouslyChosen = question.answerText;

    const [t] = useTranslation();
    const { userSettings } = useContext(ProtectedRouteContext);
    const [lang, setLang] = useState(
        typeof userSettings?.LanguagePreference === 'string' ? userSettings.LanguagePreference : i18n.language
    );
    const [chosenValue, setChosenValue] = useState(previouslyChosen);
    const [saving, setSaving] = useState(false);
    const [preSaveVal, setPreSaveVal] = useState(previouslyChosen);
    const [shouldShowErrors, setShouldShowErrors] = useState(typeof props?.shouldShowErrors === 'boolean' ? props.shouldShowErrors : false);

    const today = new Date();
    const yesterday = new Date(today);

    yesterday.setDate(today.getDate() - 1);

    const handleBlur = async (acceptedValue) => {
        var saveValue;
        if (acceptedValue?.type === 'blur') {
            saveValue = chosenValue;
        } else {
            saveValue = question?.answerText || '';
        }

        if (preSaveVal === saveValue || !question.isValid) {
            setShouldShowErrors(question.isValid === false);
            return;
        }

        setSaving(true);

        try {
            var updateAnswerResponse = await API.put('ShipyardAPI', `/application/${appInstanceId}/answer/${question.id}`, {
                body: { responseText: saveValue },
            });
        } catch (apiErr) {
            toast.error(t('General.AjaxError'));
            setChosenValue(preSaveVal);
            setSaving(false);
            return;
        }

        if (!updateAnswerResponse.success) {
            toast.error(t('General.AjaxError'));
            setChosenValue(preSaveVal);
            setSaving(false);
            return;
        }

        setSaving(false);
        setPreSaveVal(saveValue);
    };

    const handleChange = async (event) => {
        const newChosenDate = !!event && typeof event.toISOString === 'function' ? event.toISOString() : '';
        setShouldShowErrors(false);

        question.answerText = newChosenDate;
        setChosenValue(newChosenDate);
        var validity = question.validator(question);
        question.isValid = validity.isValid;
        question.invalidReason = validity.invalidReason;
        answerUpdated();
    };

    useEffect(() => {
        if (typeof userSettings?.LanguagePreference === 'string') {
            setLang(userSettings.LanguagePreference);
        }
    }, [userSettings.LanguagePreference]);

    return (
        <div
            className={
                'question-wrapper date-pick' + (!question.isValid && shouldShowErrors ? ' invalid' : '') + (disabled ? ' disabled' : '')
            }
        >
            <label>
                {question?.minResponseRequired > 0 ? <span style={{ color: '#D24444' }}>*</span> : null}
                <span>{question.text[lang]}</span>
                {saving ? (
                    <span className="saving">
                        <FontAwesomeIcon icon={faSpinner} />
                    </span>
                ) : null}
            </label>
            <DatePicker
                onChange={handleChange}
                onBlur={handleBlur}
                value={moment.tz(chosenValue || null, 'America/Chicago')}
                maxDate={moment.tz(yesterday.toISOString(), 'America/Chicago')}
                size="small"
                saving={saving}
                error={shouldShowErrors && !question.isValid}
                clearable
                textFieldSx={{
                    '.Mui-disabled': {
                        color: (theme) => theme.palette.grey['field-text'],
                    },
                }}
            />

            <span
                className="invalid-reason"
                id={'quest-err-' + question.id}
            >
                {t(question.invalidReason)}
            </span>
        </div>
    );
}

//TODO emit current saving state up to parent component

